<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{title}}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modalRef.close()"
    ></button>
  </div>
  <div class="modal-body">
    <table class="table table-bordered">
      <thead>
        <tr>
            <th *ngFor="let item of headers">{{item | uppercase}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of tableData">
          <td>{{item.verso | uppercase}}</td>
          <td>
            @if(item.crosstime){
              {{item.crosstime | uppercase}}
            }@else{
              {{item.m1 | number: '1.2-2'}} - {{item.m2 | number: '1.2-2'}}
            }
          </td>
          <td>{{item.ora}}</td>
          <td>{{item.open | number: '1.4-4'}}</td>
          <td>{{item.oraclose}}</td>
          <td>{{item.close | number: '1.4-4'}}</td>
          <td>{{item.profit | number: '1.4-4'}}</td>
        </tr>
      </tbody>
    </table>
    <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">
      Close
    </button>
    <button type="button" class="btn btn-primary">Save changes</button>
  </div>
